export function getNumericFacetSetSliceInitialState(request, tabs) {
    return { request, tabs };
}
export function getNumericFacetSetInitialState() {
    return {};
}
